import { useEffect, useState } from 'react';

import { lifecycleAPI } from '@/services/lifecycleAPI';

type Labels = Record<string, string>;

// Legal text has no copy-editor entry (graphy CopyListService leaves out
// LEGAL_STEPS), so the copy list has no label for it. Same words as graphy's
// JourneyCatalog::STEP_LABELS (review RT-11).
const LEGAL_STEP_LABELS: Labels = {
  tx_sms_opt_in: 'SMS sign-up confirmation',
};

let cache: Promise<Labels> | null = null;

export const resetStepLabelsCache = () => {
  cache = null;
};

const loadLabels = (): Promise<Labels> => {
  if (!cache) {
    cache = lifecycleAPI
      .listCopy()
      .then((items) =>
        Object.fromEntries(items.map((item) => [item.step_key, item.label])),
      )
      .catch(() => {
        cache = null;
        return {};
      });
  }
  return cache;
};

const useStepLabels = () => {
  const [labels, setLabels] = useState<Labels>({});

  useEffect(() => {
    let active = true;
    loadLabels().then((result) => {
      if (active) setLabels(result);
    });
    return () => {
      active = false;
    };
  }, []);

  return (stepKey: string) =>
    labels[stepKey] || LEGAL_STEP_LABELS[stepKey] || stepKey;
};

export default useStepLabels;
